// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__qZTVY","title":"styles_title__1CIpz","form":"styles_form__14-aI","hint":"styles_hint__1BP8B"};